import { LinkItemType, MetabaseResourceType } from '@swipe4work/models-orval'

/** Options for the type discriminator selector (create form). */
export const linkItemTypeOptions = [
  {
    label: 'Metabase dashboard',
    value: LinkItemType.MetabaseIframe,
  },
  {
    label: 'Iframe',
    value: LinkItemType.Iframe,
  },
  {
    label: 'Externe link',
    value: LinkItemType.Uri,
  },
  {
    label: 'Interne link',
    value: LinkItemType.InternalLink,
  },
]

export function linkItemTypeLabel(type: LinkItemType): string {
  switch (type) {
    case LinkItemType.MetabaseIframe:
      return 'Metabase dashboard'
    case LinkItemType.Iframe:
      return 'Iframe'
    case LinkItemType.Uri:
      return 'Externe link'
    case LinkItemType.InternalLink:
      return 'Interne link'

    default:
      return type
  }
}

export function linkItemTypeIcon(type: LinkItemType): string {
  switch (type) {
    case LinkItemType.MetabaseIframe:
      return 'fa-regular fa-chart-line'
    case LinkItemType.Iframe:
      return 'fa-regular fa-window-maximize'
    case LinkItemType.Uri:
      return 'fa-regular fa-arrow-up-right-from-square'
    case LinkItemType.InternalLink:
      return 'fa-regular fa-diagram-project'

    default:
      return 'fa-regular fa-link'
  }
}

export type LinkItemTypeAccent = {
  /** Classes for the icon chip on a homepage card. */
  icon: string
  /** Right-hand accent border class of a homepage card. */
  border: string
  /** Severity of the type tag. */
  tagSeverity: 'secondary' | 'info' | 'success' | 'warn'
}

// @unocss-include
/** Per-type accent for the homepage cards; internal links keep the neutral brand look. */
export function linkItemTypeAccent(type: LinkItemType): LinkItemTypeAccent {
  switch (type) {
    case LinkItemType.MetabaseIframe:
      return {
        icon: 'bg-info-50 text-info-600 group-hover:bg-info-100',
        border: '!border-r-info-400 group-hover:!border-r-info-500',
        tagSeverity: 'info',
      }
    case LinkItemType.Iframe:
      return {
        icon: 'bg-success-50 text-success-600 group-hover:bg-success-100',
        border: '!border-r-success-400 group-hover:!border-r-success-500',
        tagSeverity: 'success',
      }
    case LinkItemType.Uri:
      return {
        icon: 'bg-warning-50 text-warning-600 group-hover:bg-warning-100',
        border: '!border-r-warning-400 group-hover:!border-r-warning-500',
        tagSeverity: 'warn',
      }
    case LinkItemType.InternalLink:

    default:
      return {
        icon: 'bg-primary-50 text-primary-500 group-hover:bg-primary-100',
        border: 'border-r-1',
        tagSeverity: 'secondary',
      }
  }
}

export const metabaseResourceTypeOptions = [
  {
    label: 'Dashboard',
    value: MetabaseResourceType.Dashboard,
  },
  {
    label: 'Vraag',
    value: MetabaseResourceType.Question,
  },
]
